import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState, useEffect } from "react";
import Axios from "../../../api/Axios";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/Loader";
import storage from "../../../Services/Storage";
 
const url = "UserGroups/";
const GetuserGroup_url = `${url}GetAllDistributor`;
const GetDeleteuser_url = `${url}DeleteUserGroupData?`;
 
const UserGroups = () => {
    const navigate = useNavigate();
    const auth = storage.getLocal("user");
    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    console.log("userData", userData);
    // const [filters, setFilters] = useState({
    //     CODE: "",
    //     GR_NAME: "",
    //     MASK_STATUS: "",
    // });
 
    useEffect(() => {
        getUserGroup();
    }, []);
 
    const getUserGroup = async () => {
        setIsLoading(true);
        try {
            const UserGrp_Url = `${GetuserGroup_url}?CompId=${auth.CompId}`;
            const response = await Axios.get(UserGrp_Url);
            console.log("responseuser", response);
 
            setUserData(response.data.Data);
            setIsLoading(false);
        } catch (error) {
            toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.log(error);
            setIsLoading(false);
        }
    };
    // Handle Edit - Navigate to edit page with the selected row's CODE
 
    const handleEdit = (rowData) => {
        navigate("/usermanagement/usergroup/usergroupfield/details", {
            state: { selectedGroup: rowData },
        });
    };
 
    const handleDelete = async (code) => {
        try {
            const response = await Axios.post(GetDeleteuser_url, { code });
 
            if (response.status === 200) {
                setUserData((prevData) =>
                    prevData.filter((item) => item.CODE !== code)
                );
                toast.success("User Group deleted successfully!");
            } else {
                toast.error("Failed to delete user group. Please try again.");
            }
        } catch (error) {
            toast.error("Error deleting user group. Please contact support.");
            console.error("Delete Error:", error);
        }
    };
 
    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">User Groups</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end mb-2">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() =>
                                        navigate("/usermanagement/usergroup/usergroupfield/details")
                                    }
                                >
                  Add New
                                </button>
                            </div>
                        </div>
                    </div>
                    <section>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    value={userData}
                                    //                 .filter(
                                    //                     (item) =>
                                    //                         item.CODE.toLowerCase().includes(
                                    //                             filters.CODE.toLowerCase()
                                    //                         ) &&
                                    //   item.GR_NAME.toLowerCase().includes(
                                    //       filters.GR_NAME.toLowerCase()
                                    //   ) &&
                                    //   item.MASK_STATUS.toLowerCase().includes(
                                    //       filters.MASK_STATUS.toLowerCase()
                                    //   )
                                    //                 )
                                    paginator
                                    rows={10}
                                    filterDisplay="row"
                                    scrollable
                                    rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    showGridlines
                                    stripedRows
                                    // tableStyle={{ minWidth: "60rem" }}
                                    selectionMode="single"
                                    // selection={selectedRow}
                                    // onSelectionChange={(e: any) => onSelectionChange(e.value)}
                                >
                                    <Column
                                        field="CODE"
                                        header="Code"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                        // body={(rowData) => rowData.CODE}
                                        // filterElement={() => (
                                        //     <input
                                        //         type="text"
                                        //         value={filters.CODE}
                                        //         onChange={(e) =>
                                        //             setFilters({ ...filters, CODE: e.target.value })
                                        //         }
                                        //         placeholder="Search Here..."
                                        //         className="p-inputtext-sm w-60 rounded"
                                        //     />
                                        // )}
                                    ></Column>
                                    <Column
                                        field="GR_NAME"
                                        header="Name"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                        // body={(rowData) => rowData.GR_NAME}
                                        // filterElement={() => (
                                        //     <input
                                        //         type="text"
                                        //         value={filters.GR_NAME}
                                        //         onChange={(e) =>
                                        //             setFilters({ ...filters, GR_NAME: e.target.value })
                                        //         }
                                        //         placeholder="Search Here..."
                                        //         className="p-inputtext-sm w-60 rounded"
                                        //     />
                                        // )}
                                    ></Column>
                                    <Column
                                        field="MASK_STATUS"
                                        header="Status"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                        // body={(rowData) => rowData.MASK_STATUS}
                                        // filterElement={() => (
                                        //     <input
                                        //         type="text"
                                        //         value={filters.MASK_STATUS}
                                        //         onChange={(e) =>
                                        //             setFilters({
                                        //                 ...filters,
                                        //                 MASK_STATUS: e.target.value,
                                        //             })
                                        //         }
                                        //         placeholder="Search Here..."
                                        //         className="p-inputtext-sm w-60 rounded"
                                        //     />
                                        // )}
                                    ></Column>
                                    <Column
                                        header="User Group Privileges"
                                        body={(rowData) => (
                                            <a
                                                onClick={() =>
                                                    navigate(
                                                        `/usermanagement/usergroup/privilage?GRID=${encodeURIComponent(rowData.MASK_GR_ID)}&New=N`
                                                    )
                                                }
                                                className=""
                                            >
                        Go to Privileges <Fa.FaLongArrowAltRight className="ms-2"/>
                                            </a>
                                        )}
                                    />
                                    <Column
                                        header="Action"
                                        body={(rowData) => (
                                            <div className="action-icon">
                                                <button
                                                    className="grid-icon-img"
                                                    onClick={() => handleEdit(rowData)}
                                                    title="View/Edit"
                                                >
                                                    <img
                                                        alt="InnoRise"
                                                        src={require("../../../Assets/Images/ViewEdit.png")}
                                                    />
                                                </button>
                                                <button
                                                    className="grid-icon"
                                                    title="Delete"
                                                    onClick={() => handleDelete(rowData.CODE)}
                                                >
                                                    <Fa.FaTrashAlt className="cancel" />
                                                </button>
                                            </div>
                                        )}
                                    ></Column>
                                    {/* <p>View/Edit Icon and Delete Icon</p> */}
                                </DataTable>
                            </div>
                        </div>
                    </section>
                </div>
            )}
        </>
    );
};
 
export default UserGroups;